import { ProjectCard } from "./ProjectCard";
import { useContext } from "react";
import { LanguageContext } from "../../../components/LanguageProvider";
import { BackToTopButton } from "./BackToTopButton/BackToTopButton";

export const MyProjectsContainer = () => {
  const { polish } = useContext(LanguageContext);

  return (
    <div className="projects-container px-4 md:px-0 w-full mb-20">
      {!polish && (
        <div className="w-4/6 h-12 md:h-48 flex md:justify-center items-center">
          <h3 className="text-white text-[1rem] md:text-2xl">My projects</h3>
        </div>
      )}

      {polish && (
        <div className="w-4/6 h-12 md:h-48 flex md:justify-center items-center">
          <h3 className="text-white text-[1rem] md:text-2xl">Moje projekty</h3>
        </div>
      )}

      <ProjectCard
        projectName="Luisa Cerano E-commerce"
        projectImage="lc.webp"
        projectDescriptionEng="I successfully integrated all WooCommerce features with the application without making any structural changes to the existing CMS itself. This also required developing custom PHP plugins. Soon to be released."
        projectDescriptionPl="Głównym wyzwaniem było zbudowanie aplikacji tak, by nie zmieniać istniejącego CMS opartego na WooCommerce. Korzystając z API i stworzonych przeze mnie customowych pluginów, zintegrowałam wszytkie funkcjonalności WooCommerce z aplikacją Next.js."
        technologies={[
          "Next.js 14 App Router",
          "Typescript",
          "Node.js",
          "Wordpress CMS",
          "WooCommerce",
          "REST API",
          "Material Design",
        ]}
        links={[
          {
            linkNameEng: "Application",
            linkNamePl: "Aplikacja",
            link: "https://luisa-cerano.vercel.app",
          },
        ]}
      />

      <ProjectCard
        projectName="Forbis Group"
        projectImage="forbis.webp"
        projectDescriptionEng="Next.js application created for Forbis Group headless Wordpress CMS. Fully responsive and SEO friendly. "
        projectDescriptionPl="Aplikacja stworzona dla Forbis Group. Napisana w Next.js App Router. Oparta na Wordpress CMS (headless). W pełni responsywna i przyjazna wyszukiwarkom."
        technologies={[
          "Next.js 14 App Router",
          "Typescript",
          "Node.js",
          "Wordpress CMS",
          "Google Maps API",
          "REST API",
          "Material Design",
        ]}
        links={[
          {
            linkNameEng: "Application",
            linkNamePl: "Aplikacja",
            link: "https://www.forbisgroup.pl/",
          },
        ]}
      />

      <ProjectCard
        projectName="JCB Interhandler"
        projectImage="jcb.webp"
        projectDescriptionEng="Next.js 14 application created for JCB Interhandler with headless Wordpress CMS. Fully responsive and SEO friendly."
        projectDescriptionPl="Aplikacja stworzona przeze mnie dla JCB Interhandler. Napisana w Next.js 14 App Router. Oparta na Wordpress CMS (headless). W pełni responsywna i przyjazna wyszukiwarkom."
        technologies={[
          "Next.js 14 App Router",
          "Typescript",
          "Node.js",
          "Wordpress CMS",
          "Facebook Graph API",
          "REST API",
          "Material Design",
          "Docker",
        ]}
        links={[
          {
            linkNameEng: "Application",
            linkNamePl: "Aplikacja",
            link: "https://www.interhandler.pl/",
          },
        ]}
      />

      <ProjectCard
        projectName="Techniki Zamocowań - e-commerce app"
        projectImage="tzlf.png"
        projectDescriptionEng="An e-commerce application of my design, written in Next.js with Firebase as backend. It is fully responsive. Its release is planned for the end of the year."
        projectDescriptionPl="Aplikacja e-commerce, którą zaprojektowałam i zbudowałam. Napisana w Next.js, z backendem w Firebase. Release planowany jest na koniec tego roku."
        technologies={[
          "React.js",
          "Typescript",
          "Next.js",
          "Node.js",
          "SCSS",
          "Firebase v9",
          "Sendgrid",
        ]}
        links={[
          {
            linkNameEng: "Application",
            linkNamePl: "Aplikacja",
            link: "https://techniki-zamocowan.vercel.app/",
          },
          {
            linkNameEng: "Design in Figma",
            linkNamePl: "Projekt w Figmie",
            link: "https://www.figma.com/file/FPSE6aFEqlcocQgoMaUDhX/Techniki-Zamocowa%C5%84?type=design&node-id=0%3A1&t=aDpwgQeWME804Lfa-1",
          },
        ]}
      />

      <ProjectCard
        projectName="Techniki Zamocowań - website"
        projectImage="tzstronalf.png"
        projectDescriptionEng="A simple application I have designed and coded in Next.js. Created as a website for the same company as above."
        projectDescriptionPl="Prosta aplikacja, którą zaprojektowałam i napisałam w Next.js. Stworzona jako strona internetowa dla Technik Zamocowań."
        technologies={[
          "React.js",
          "Typescript",
          "Next.js",
          "Sass",
          "Firebase v9",
          "Algolia",
        ]}
        links={[
          {
            linkNameEng: "Application",
            linkNamePl: "Aplikacja",
            link: "https://tech-zam-strona.vercel.app/",
          },
          {
            linkNameEng: "Design in Figma",
            linkNamePl: "Projekt w Figmie",
            link: "https://www.figma.com/file/zvloJHN1RuJZ8IXqIQOyJt/Techniki-zamocowa%C5%84-strona?type=design&node-id=0%3A1&t=ScNhUIHjdZSGUo8C-1",
          },
        ]}
      />

      <ProjectCard
        projectName="CoolArtDesign Architecture"
        projectImage="coolart.png"
        projectDescriptionEng="A simple Next.js application designed and built for an architect."
        projectDescriptionPl="Prosta aplikacja, którą zaprojektowałam i zbudowałam w Next.js."
        technologies={["Next 13", "Tailwind", "Zustand"]}
        links={[
          {
            linkNameEng: "Application",
            linkNamePl: "Aplikacja",
            link: "https://coolartdesign-v2-0.vercel.app/",
          },
          {
            linkNameEng: "Figma design",
            linkNamePl: "Figma",
            link: "https://www.figma.com/file/6LNZgqPOfvHr69AJ6UGWtD/CoolArtDesign-Architecture?type=design&node-id=0%3A1&mode=design&t=uQwAHbjjz5IwiGl9-1",
          },
        ]}
      />

      <ProjectCard
        projectName="Bookshare"
        projectImage="BookShare.png"
        projectDescriptionEng="React application of my idea and design created as a bootcamp final project. "
        projectDescriptionPl="Reactowa aplikacja stworzona jako końcowy projekt bootcampowy. Pracowaliśmy w SCRUMie w 3-osobowym zespole."
        technologies={[
          "React.js",
          "Typescript",
          "Node.js",
          "Firebase v9, Google Books API, MUI",
        ]}
        links={[
          {
            linkNameEng: "Application",
            linkNamePl: "Aplikacja",
            link: "https://bookshare-react.netlify.app/",
          },
          {
            linkNameEng: "Design in Figma",
            linkNamePl: "Projekt w Figmie",
            link: "https://www.figma.com/file/HiDWWAOSVMWauUqFiFgX45/Bookshare?type=design&node-id=0%3A1&mode=design&t=2OZWrSW75UNZPCtu-1",
          },
        ]}
      />

      <BackToTopButton />
    </div>
  );
};
